import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import './BottomNav.css';

/* 모바일 하단 네비게이션 — 홈/커뮤니티/도구/대시보드/프로필.
   데스크탑에서는 CSS로 숨김(헤더 네비 유지). */

function HomeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 9.8 12 3l9 6.8" />
      <path d="M5.2 9.4V20a1 1 0 0 0 1 1h11.6a1 1 0 0 0 1-1V9.4" />
    </svg>
  );
}

function CommunityIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3.4 19.2c0-3.1 2.5-5.2 5.6-5.2s5.6 2.1 5.6 5.2" />
      <path d="M16.2 5.5a3 3 0 0 1 0 5.6" />
      <path d="M17 14.2c2.3.3 4 2.3 4 5" />
    </svg>
  );
}

function DashboardIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.4" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.4" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.4" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.4" />
    </svg>
  );
}

function ProfileIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="8" r="3.6" />
      <path d="M5 20c0-3.6 3.1-6.2 7-6.2s7 2.6 7 6.2" />
    </svg>
  );
}

const TABS = [
  { key: 'home', path: '/', Icon: HomeIcon, requiresAuth: false },
  { key: 'community', path: '/community', Icon: CommunityIcon, requiresAuth: false },
  { key: 'dashboard', path: '/dashboard', Icon: DashboardIcon, requiresAuth: true },
  { key: 'profile', path: '/profile', Icon: ProfileIcon, requiresAuth: true },
];

function isActive(pathname, path) {
  if (path === '/') return pathname === '/';
  return pathname === path || pathname.startsWith(path + '/');
}

export default function BottomNav({ onRequireLogin }) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleClick = (tab) => {
    if (tab.requiresAuth && !user) {
      if (onRequireLogin) onRequireLogin();
      return;
    }
    // 키보드가 떠있는 상태로 탭 이동하면 크롬 모바일이 페이지를 위로 스크롤한 상태가 남아
    // 새 탭이 화면 위로 올라간 채 그려짐 → 이동 전에 입력 포커스 해제로 키보드를 닫음
    const active = document.activeElement;
    if (active && typeof active.blur === 'function') {
      const tag = active.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || active.isContentEditable) {
        active.blur();
      }
    }
    if (location.pathname === tab.path) {
      window.scrollTo(0, 0);
      return;
    }
    navigate(tab.path);
  };

  return (
    <nav className="lansly-bottom-nav" aria-label={t('nav.ariaLabel')}>
      {TABS.map((tab) => {
        const active = isActive(location.pathname, tab.path);
        const { Icon } = tab;
        return (
          <button
            key={tab.key}
            type="button"
            className={`lansly-bottom-nav-item${active ? ' is-active' : ''}`}
            onClick={() => handleClick(tab)}
            aria-current={active ? 'page' : undefined}
          >
            <span className="lansly-bottom-nav-icon">
              <Icon />
            </span>
            <span className="lansly-bottom-nav-label">{t(`nav.${tab.key}`)}</span>
          </button>
        );
      })}
    </nav>
  );
}
